
import AV from "leancloud-storage";
import { User } from "@/models";
import Actionsheet from 'vux/src/components/actionsheet/index.vue'

import TabNavNormal from '@/components/tab/TabNavNormal.vue'
import { setTimeout } from 'timers';
import PageChanger from '@/components/PageChangerBasic.vue'
import QrCodeDialog from '@/components/QrCodeDialog.vue'
import { mapGetters } from 'vuex'



const mapNav = [

['文库', { name: 'library' }],
['活动', { name: 'game' }],
['作者', { name: 'navAuthor' }],
['作品', { name: 'navPoetry' }],
['名句', { name: 'navQuote' }],
['词牌', { name: 'navCipai' }],
['诗单', { name: 'lists' }],
]







export default {
name: "EduContent",
metaInfo: {
title: "西窗烛",
titleTemplate: "%s · 西窗烛"
},
created () {

this.pc = this.isPC()

if (this.pc) {
this.navType.main = true
this.navType.changer = !(this.notShowNavChanger.findIndex(mem => mem === this.$route.name) > -1)
this.navType.fixed = false
this.navType.fixedTop = false
} else {
this.navType.main = false
this.navType.fixed = true
this.navType.fixedTop = true
}

this.selectedIndex = mapNav.findIndex(mem => mem[1].name === this.$route.name)

},
data () {
return {
showUserMenu: false,
userMenu: [
{
value: "logOut",
label: "退出帐号",
type: "warn"
}
],

navType: {
main: false,
fixed: true,
fixedTop: true
},


list: [

'文库',
'活动',
'作者',
'作品',
'名句',
'词牌',
'诗单',
],
pc: true,
selectedIndex: 0,
};
},

watch: {
$route: {
handler (to, from) {
this.navType.main = this.pc && !(this.notShowNavMain.findIndex(mem => mem === to.name) > -1)
this.navType.fixed = !this.pc && !(this.notShowNavFixed.findIndex(mem => mem === to.name) > -1)
this.navType.changer = !(this.notShowNavChanger.findIndex(mem => mem === to.name) > -1)
},
immediate: true
},

},

methods: {


isPC () {
let userAgentInfo = navigator.userAgent
let Agents = new Array("Android", "iPhone", "SymbianOS", "Windows Phone", "iPad", "iPod")
let flag = true

for (let v = 0; v < Agents.length; v++) {
if (userAgentInfo.indexOf(Agents[v]) > 0) {
flag = false
break
}
}

return flag
},

simulateClickBarItem: function (index) {
this.clickBarItem(index)
},

clickBarItem: function (index, keyword) {

setTimeout(() => {
this.selectedIndex = index

let obj = mapNav.find(mem => mem[0] === this.list[index])[1]


if (!obj.name && obj.path) {
window.location = obj.path;

return
}


this.$router.push(obj)
}, 100)
},

clickUserMenu: function (key, item) {
if (key == "logOut") {
User.logOut();
this.$store.commit("logOut");
}
},

logInAction: function () {
this.$router.push({
name: "logInSelection",
query: { from: this.$route.path }
});
},

goToCipai: function () {
this.$router.push({ name: 'navCipai' })
},

goToLists: function () {
this.$router.push({ name: 'lists' })
},


goToXCZim: function () {
window.location = "http://www.xcz.im";
},

goToLibrary: function () {
this.$router.push({ name: "library" });
},

goToGame: function () {
this.$router.push({ name: "game" });
},

goToShop: function () {
window.location = "https://h5.youzan.com/v2/feature/3h6qpijj";
},

goToNavAuthor: function () {
this.$router.push({ name: "navAuthor" });
},

goToNavQuote: function () {
this.$router.push({ name: "navQuote" });
},

goToNavPoetry: function () {
this.$router.push({ name: "navPoetry" });
}
},
computed: {
...mapGetters(['user', 'notShowNavFixed', 'notShowNavMain', 'notShowNavChanger']),

isHuawei: function () {
return this.$route.query.pro;
},

headerType: function () {
if (!this.$route.path) {
return this.header
}

let firstPath = this.$route.path.match(/\/([^\/]*)/)[1]
let header = this.header
let count = 0

for (const key in header) {
if (key === firstPath) {
header[key] = true
count++
} else {
header[key] = false
}
}

if (count == 0) {
header.main = true
}

return header
},

pageClass: function () {
if (!this.$route.name) {
return null;
}

return (
"page-" +
this.$route.name
.replace(/\.?([A-Z])/g, function (x, y) {
return "-" + y.toLowerCase();
})
.replace(/^-/, "")
.replace(/-{2,}/, "-")
);
}
},
components: {
Actionsheet,
TabNavNormal,
PageChanger,
QrCodeDialog

}
};



// WEBPACK FOOTER //
// ./src/pages/layouts/Edu.vue